export default "__VITE_ASSET__D1vqfnAd__"